import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  offerLetterTemplates: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.offerLetterTemplates`,
    defaultMessage: 'Offer letter templates',
  },
  none: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.none`,
    defaultMessage: 'None',
  },
  noContractType: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.noContractType`,
    defaultMessage: 'No contract type',
  },
  selectTemplateAriaLabel: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.selectTemplateAriaLabel`,
    defaultMessage: 'Select an offer letter template for {contractType}',
  },
  noTemplatesYet: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.noTemplatesYet`,
    defaultMessage:
      'No offer letter templates yet. {link} to assign one to this stage.',
  },
  createTemplatesLink: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.createTemplatesLink`,
    defaultMessage: 'Create a template',
  },
  inactiveTemplateOption: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.inactiveTemplateOption`,
    defaultMessage: '{title} (deactivated)',
  },
  inactiveTemplateHint: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.OfferLetterTemplates.inactiveTemplateHint`,
    defaultMessage:
      'This template has been deactivated. Pick another template, or None, to remove it from this stage.',
  },
});
